export default __webpack_public_path__ + "static/media/image1.98d81e6c.png";